import { render, staticRenderFns } from "./QuickResponsesIcon.vue?vue&type=template&id=368b3624&"
import script from "./QuickResponsesIcon.vue?vue&type=script&lang=js&"
export * from "./QuickResponsesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports